module.exports = __webpack_public_path__ + "static/media/info01.cfa1f595.png";